import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { ErrorComponent } from "@components/ErrorComponent";
import { Loader } from "@components/Loader";
import { GoalsContextProvider } from "@contexts";
import {
  useDashboardModals,
  useGoalsOverviewPrefetch,
  useIntercom,
  useNextTransfer,
  usePastTransactions,
  usePromotionalDollarQuery,
  useUser,
} from "@hooks";
import { Analytics } from "@services";
import { getRouteForPath } from "@utils";
import { Home } from "./Home";

export const DashboardRoute = () => {
  const location = useLocation();

  const route = getRouteForPath(location.pathname);

  const { loading: userLoading, error: userError } = useUser();
  const { loading: nextTransferLoading, error: nextTransferError } = useNextTransfer();
  const { loading: promoLoading, error: promoError } = usePromotionalDollarQuery();

  const loading = userLoading || nextTransferLoading || promoLoading;
  const error = userError || nextTransferError || promoError;

  useIntercom();
  useGoalsOverviewPrefetch();
  usePastTransactions();
  useDashboardModals();

  useEffect(() => {
    Analytics.page(route);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <Loader />;
  if (error) return <ErrorComponent />;

  return (
    <GoalsContextProvider>
      <Home />
    </GoalsContextProvider>
  );
};
